interface Config {
  apiHost: string;
  socketHost: string;
  boothHost: string;
  displayHost: string;
}

/**
 * Was `process.env.NX_*`, substituted by webpack at build time.
 *
 * `apiHost` now defaults to empty, meaning same-origin: the admin bundle is
 * served by the same Caddy that proxies /api, so there is no cross-origin
 * setup to keep in step and nothing environment-specific baked into the JS.
 */
const env = import.meta.env;

const config: Config = {
  apiHost: env.VITE_API_HOST ?? '',
  socketHost: env.VITE_SOCKET_HOST ?? '',
  boothHost: env.VITE_BOOTH_HOST ?? '',
  displayHost: env.VITE_DISPLAY_HOST ?? ''
};

export default config;
